import { TfsService } from "Presentation/Scripts/TFS/TFS.Service";
import { WorkCustomizationHubData, WorkCustomizationHubFieldData } from "TFS/WorkCustomization/DataProviderContracts";
import { IProcess } from "WorkCustomization/Scripts/Contracts/Process";
import * as WorkContracts from "TFS/WorkItemTracking/Contracts";
import Contribution_Services = require("VSS/Contributions/Services");
import Service = require("VSS/Service");

export class PageDataService extends TfsService {
    public static PAGE_DATA_PROVIDER_ID = "ms.vss-work-web.work-customization-hub-data-provider";
    public static FIELDS_PAGE_DATA_PROVIDER_ID = "ms.vss-work-web.work-customization-hub-fields-data-provider";

    public getAllProcesses(): IProcess[] {
        let dataSvc = Service.getService(Contribution_Services.WebPageDataService);
        return dataSvc.getPageData<WorkCustomizationHubData>(PageDataService.PAGE_DATA_PROVIDER_ID).processes;
    }

    public getAllowedValues(): IDictionaryStringTo<string[]> {
        let dataSvc = Service.getService(Contribution_Services.WebPageDataService);
        return dataSvc.getPageData<WorkCustomizationHubFieldData>(PageDataService.FIELDS_PAGE_DATA_PROVIDER_ID).allowedValues;
    }

    public getFields(): WorkContracts.WorkItemField[] {
        let dataSvc = Service.getService(Contribution_Services.WebPageDataService);
        return dataSvc.getPageData<WorkCustomizationHubFieldData>(PageDataService.FIELDS_PAGE_DATA_PROVIDER_ID).fields;
    }

    public getControlContributionInputLimit(): number {
        let dataSvc = Service.getService(Contribution_Services.WebPageDataService);
        return dataSvc.getPageData<WorkCustomizationHubData>(PageDataService.PAGE_DATA_PROVIDER_ID).controlContributionInputLimit;
    }

    public beginReloadPageData(): IPromise<WorkCustomizationHubData> {
        let dataSvc = Service.getService(Contribution_Services.WebPageDataService);
        return dataSvc
            .invalidateCachedProviderData(PageDataService.PAGE_DATA_PROVIDER_ID, true)
            .then(() => dataSvc.getPageData<WorkCustomizationHubData>(PageDataService.PAGE_DATA_PROVIDER_ID));
    }

    public beginReloadFieldsPageData(): IPromise<WorkCustomizationHubFieldData> {
        let dataSvc = Service.getService(Contribution_Services.WebPageDataService);
        return dataSvc
            .invalidateCachedProviderData(PageDataService.FIELDS_PAGE_DATA_PROVIDER_ID, true)
            .then(() => dataSvc.getPageData<WorkCustomizationHubFieldData>(PageDataService.FIELDS_PAGE_DATA_PROVIDER_ID));
    }

    public getCanCreateProcess(): boolean {
        let dataSvc = Service.getService(Contribution_Services.WebPageDataService);
        return dataSvc.getPageData<WorkCustomizationHubData>(PageDataService.PAGE_DATA_PROVIDER_ID).canCreateProcess;
    }
}
